module.exports = __webpack_public_path__ + "static/media/third-time-lucky.0722a3bd.svg";